import React from "react"
import { Modal } from "./Modal"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { Spacer } from "../atoms/Atoms"
import { H2 } from "@carrotfertility/carotene"
import { IlloPaperAirplaneCircle } from "../atoms/Illustrations"
import styled from "styled-components"

const MainDiv = styled.div`
  text-align: left;
  padding: 48px 48px 24px 48px;
  max-width: 600px;
`

const IconDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 32px;
`

const MainBody = styled.p`
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  margin-top: 4px;
`

const MainBold = styled.span`
  font-weight: bold;
`

const ButtonDiv = styled.div`
  text-align: right;
  padding-right: 24px;
  padding-bottom: 24px;
`

export const MessageReceivedModal = ({ onExit, personalEmail, employeeEmail, partnerEmail, sentFromPartnerEmail }) => {
  return (
    <Modal underlayClickExits={false} onExit={onExit} titleText="Message received!" showCloseButton={false}>
      <MainDiv>
        <IconDiv>
          <IlloPaperAirplaneCircle />
        </IconDiv>
        <H2 className="black-80">Message received!</H2>
        <MainBody className="black-80">
          {`We’ll get back to you at `}
          <MainBold>{sentFromPartnerEmail ? partnerEmail : personalEmail ?? employeeEmail}</MainBold>
          {`, your `}
          {sentFromPartnerEmail ? `partner's` : personalEmail ? `preferred` : `account`}
          {` email.`}
        </MainBody>
      </MainDiv>
      <ButtonDiv>
        <ButtonPrimary onClick={onExit} to="/">Close</ButtonPrimary>
      </ButtonDiv>
    </Modal>
  )
}

export default MessageReceivedModal